export default __webpack_public_path__ + "static/padlock-2b6fe8a82b5ad0c1a05a24055ffc0b81.png";